export default "__VITE_ASSET__CLJD4E8V__"